import { css } from "@emotion/core";

export const joiningStepsStyle = (isMobile: boolean) => css`
  .img-container {
    width: 3em;
    height: 3em;
    img {
      margin: 0em;
    }
  }
  ${isMobile &&
  `
        .img-container {
            margin-right: 1.9em;
        }
    `}
  ${!isMobile &&
  `
        .img-container {
            margin-bottom: 1.6em;
        }
        .responsive-widget-item {
            align-items: center;
        }
    `}
`;
